export default __webpack_public_path__ + "static/media/srisailamDeitieTwo.9f0320f8.png";